import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle2 ellipsis" }
const _hoisted_2 = { class: "text-h4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "sfx-card__icon-row-margin self-end q-mt-lg"
}

import { date } from "quasar"
import SfxCard from "src/components/card/SfxCard.vue"
import SfxDataPoint from "src/components/data-point/SfxDataPoint.vue"
import SfxIconRow from "src/components/special/SfxIconRow.vue"
import { useCacheStore } from "src/stores/cacheStore"
import { DATE_TIME_FULL_MASK } from "src/util/constants/configurations"
import { CORRECTIVE_WORK_IMG, REGULAR_WORK_IMG } from "src/util/constants/files"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { getWorkOrderPriorityColor } from "src/util/functions/workOrderPriority"
import { IconRowElement } from "src/util/types/components/sfxIconRow"
import { WorkOrderCardData } from "src/util/types/dataModels/workOrder"
import { computed, PropType, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardWorkOrderForEntity',
  props: {
  workOrder: {
    type: Object as PropType<WorkOrderCardData>,
    required: true,
  },

  workPerformed: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const cacheStore = useCacheStore()

const storeWork = ref<WorkOrderCardData>()
const workTypeThumbnail = ref<string | undefined>()
const workDomainRaw = ref(props.workOrder?.workDomainData)
const workIconsRaw = ref(props.workOrder?.icons)

const workDomain = computed(() => workDomainRaw.value?.designation)

const workStatementTitle = computed(() => props.workOrder?.workOrderData.designation)

const deadline = computed(() =>
  props.workOrder?.workOrderData.deadline_dt
    ? date.formatDate(props.workOrder.workOrderData.deadline_dt, DATE_TIME_FULL_MASK)
    : t("time.not_applicable")
)

const workDescription = computed(() => props.workOrder?.workOrderData.instructions)

const workIcons = computed(() => workIconsRaw.value || [])

const classes = computed(() => {
  return { "sfx-card-work-order-for-entity": props.workPerformed }
})

//endregion

//region Functions

function assignData(workOrder: WorkOrderCardData) {
  resetData()

  storeWork.value = cacheStore.workOrderCard.get(workOrder.workOrderData.id)

  assignThumbnailIcon(workOrder.isCorrectiveWork)
  assignWorkDomain(workOrder.workOrderData.work_domain)
  assignIcons(workOrder)
}

function resetData() {
  workTypeThumbnail.value = undefined
  workDomainRaw.value = undefined
  workIconsRaw.value = undefined
}

async function assignThumbnailIcon(isCorrectiveWork: boolean) {
  workTypeThumbnail.value = isCorrectiveWork ? CORRECTIVE_WORK_IMG : REGULAR_WORK_IMG
}

function assignWorkDomain(workDomainId: string) {
  // We already have the data so skip it
  if (workDomainRaw.value) return

  const workDomainData = cacheStore.work_domain_workspace.get(workDomainId)

  workDomainRaw.value = workDomainData

  if (storeWork.value) storeWork.value.workDomainData = workDomainData
}

function assignIcons(workOrder: WorkOrderCardData) {
  if (workIconsRaw.value !== undefined) return

  const iconRow: IconRowElement[] = []
  iconRow.push(
    { name: Icons.WORK_ORDERS, color: getWorkOrderPriorityColor(workOrder.priorityData) },
    { name: Icons.ACCEPT, color: props.workPerformed ? "positive" : undefined }
  )

  workIconsRaw.value = iconRow

  if (storeWork.value) storeWork.value.icons = iconRow
}

//endregion

//region Setup Code

watch(
  () => props.workOrder,
  async (newWork) => {
    assignData(newWork)
  },
  { immediate: true }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _directive_truncate_middle = _resolveDirective("truncate-middle")!

  return (_openBlock(), _createBlock(SfxCard, {
    class: _normalizeClass(["q-mb-sm", classes.value]),
    "img-src": workTypeThumbnail.value,
    "img-fit": 'none',
    clickable: "",
    hasImg: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(workDomain.value), 1),
      _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
        [_directive_truncate_middle, workStatementTitle.value]
      ]),
      _createVNode(SfxDataPoint, {
        "card-field": "",
        label: _ctx.$t('sfxCard.deadline')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(deadline.value), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SfxDataPoint, {
            "card-field": "",
            label: _ctx.$t('sfxCard.work_description')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(workDescription.value), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        (workIcons.value?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(SfxIconRow, { icons: workIcons.value }, null, 8, ["icons"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["class", "img-src"]))
}
}

})